// src/app/auth/auth-guard.service.ts

import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Resolve} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router/src/router_state';

@Injectable()
export class AuthGuardService implements CanActivate, Resolve<Object> {
  public loggedIn = false;

  constructor(public router: Router, public http: HttpClient) {}


  resolve(route: ActivatedRouteSnapshot): Promise<Object>| boolean {
    return this.isLoggedIn().toPromise()
        .then(res => {
          if (res && res['logged'] && res['logged'] === true) {
            this.loggedIn = res['logged'];
            this.router.navigate(['home']);
            return true;
          } else {
            this.loggedIn = false;
            return false;
          }
        })
        .catch(err => {
          this.loggedIn = false;
          return false;
        });
  }

  public canActivate(): boolean {
    if (this.loggedIn) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }

  public canShowRegister(): boolean {
    return !this.loggedIn;
  }

  public isLoggedIn() {
    //changed to post to solve IE issues with cache
    return this.http.post('/accounts/isLogged',{
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache'
      }
    })
  }

  public login(email, password) {
    const options = {withCredentials: true};
    return this.http.post(
        '/accounts/login', {username: email, password: password}, options);
  }

  public logout() { 
    return this.http.post('/accounts/logout', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache'
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts